module.exports = __webpack_public_path__ + "static/media/Logo-Finsa.ce670eb5.png";